module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "border-radius-welcome",
    style: ({
      'background-color': _vm.$store.state.campaign.color,
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [(this.$store.state.isLowRes) ? _c('v-btn', {
    staticClass: "right-arrow-back",
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.minimizeWindow.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "28px !important"
    },
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_vm._v("keyboard_arrow_left")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "vtext-content",
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.getText)
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b3c0858"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/welcome-message.vue
// module id = 413
// module chunks = 2